import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getTrans as T } from "../../../Shared/Language";
import moment from "moment";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import {
  deleteEmployeeAwards,
  getEmployeeAwards,
} from "./Services/awardService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);
function AwardDetails() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const { AwardId } = useParams();
  const [loading, setLoading] = useState(false);
  const [awardData, setAwardList] = useState();
  const [awardDeleteId, setAwardDeleteId] = useState(0);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  let history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "");
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const defaultAwardImage = "/images/no-data-found/Award_dummy.svg";
  useEffect(() => {
    getAwardList();
    permissionAwardList();
  }, []);

  const permissionAwardList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Award.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Award.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Award.Delete") {
        setDeleted(true);
      }
    });
  };

  async function getAwardList() {
    setLoading(true);
    const params = {
      OrgId: userDetails.OrgId,
      LoggedInUserId: 0,
      year: "",
      AwardNumber: AwardId,
      Awardid: 0,
      PageNumber: 1,
      PageSize: 10,
    };
    try {
      const response = await getEmployeeAwards(params);
      setAwardList(response?.Data[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function deleteAcademicDetails() {
    setLoading(true);
    if (awardDeleteId) {
      let body = {
        Id: awardDeleteId,
        ModifiedBy: userDetails?.EmpId,
      };
      setLoading(true);
      try {
        let awardDeleteList = await deleteEmployeeAwards(body);
        if (awardDeleteList) {
          GetMasterSystemAlertList("Award Deleted", 0);
          setLoading(false);
          document.getElementById("delete-ed").click();
          history.push(`/Awards`);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const handleAwardImageError = useCallback((event) => {
    event.target.src = defaultAwardImage; // Set the fallback image on error
  }, []);

  return (
    <>
      <div id="circular-menu" className="circular-menu position-relation">
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </Link>
        </div>
      </div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row">
                <div className="col-md-8 shrink-w">
                  <div className="form-head d-flex flex-wrap align-items-center mb-4">
                    <div className="me-auto">
                      <h2 className="font-w600 mb-0">{T("Award Detail")}</h2>
                    </div>
                    <div className="rightside-tabs">
                      {update && (
                        <Link to={`/Award/Edit/${AwardId}`} title="Edit">
                          <button className="back-newticket w-auto float-right mr-3">
                            Edit
                          </button>
                        </Link>
                      )}
                      {deleted && (
                        <button
                          type="button"
                          className="article-deletebtn"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-ed"
                          title="Delete"
                          data-bs-original-title="delete"
                          aria-label="delete"
                          style={{ width: "84px" }}
                          onClick={() => setAwardDeleteId(awardData?.id)}
                        >
                          Delete
                        </button>
                      )}
                      <Link to="/Awards">
                        <button className="back-newticket w-auto float-right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-arrow-left-short"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                            />
                          </svg>{" "}
                          Back
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-8">
                      <div className="employee-card tile-grid tile-grid-v1">
                        <div id="feed-post-1" className="AnnouncementForm">
                          <div className="third-section">
                            <div className="row">
                              <div className="mb-4 col-md-12">
                                <label className="form-label">Name</label>
                                <div className="cover-form">
                                  <i
                                    className="fa fa-user"
                                    aria-hidden="true"
                                  ></i>
                                  <p className="filledannoucement">
                                    {awardData?.EmployeeName}
                                  </p>
                                </div>
                              </div>
                              <div className="mb-4 col-md-12">
                                <label className="form-label">Award</label>

                                <div className="cover-form">
                                  <i
                                    className="fa fa-trophy"
                                    aria-hidden="true"
                                  ></i>
                                  <p className="filledannoucement">
                                    {awardData?.AwardName}
                                  </p>
                                </div>
                              </div>
                              <div className="mb-4 col-md-12">
                                <label className="form-label">
                                  Description
                                </label>

                                <div className="cover-form">
                                  <p className="filledannoucement seth break-text">
                                    {awardData?.Desc}
                                  </p>
                                </div>
                              </div>
                              <div className="mb-4 col-md-12">
                                <label className="form-label">Date</label>

                                <div className="cover-form">
                                  <i
                                    className="fa fa-calendar-o "
                                    aria-hidden="true"
                                  ></i>
                                  <p className="filledannoucement">
                                    {moment(awardData?.Date).format(
                                      "MMM DD YYYY"
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className="mb-4 col-md-12 d-none">
                                <label className="form-label">Image</label>
                                <div className="cover-form">
                                  {awardData?.Image ? (
                                    <div className="announcementimg">
                                      <LazyImage
                                        src={awardData.Image}
                                        width="32"
                                      />
                                    </div>
                                  ) : (
                                    <div className="icon-bell">
                                      <img
                                        src="images/org-img/imp.png"
                                        className=""
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className="row">
                        <div className="col-xl-12">
                          <label className="form-label"></label>
                          <div className="card">
                            <div className="card-body">
                              <div className="loadresumes">
                                <div className="inner">
                                  {awardData ? (
                                    <img
                                      src={
                                        awardData?.awardImage ||
                                        defaultAwardImage
                                      }
                                      onError={handleAwardImageError}
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      src="/images/org-img/learn/add.png"
                                      className=""
                                    />
                                  )}
                                </div>
                                <input
                                  type="file"
                                  className="form-control"
                                  name="BannerImage"
                                  accept="image/png, image/gif, image/jpeg"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="delete-ed">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                <p>Do you really want to delete this award?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => deleteAcademicDetails()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Suspense >
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default AwardDetails;
